
<template>
  <div ref="SchedulerComponent"></div>
</template>

<script>
import { scheduler } from "dhtmlx-scheduler";
import { DefaultBookingType, DefaultBookingStatus } from './data';

function dateFormJoiner(date) {
  const dateStr = String(date);
  const dateParts = dateStr.split(' ');
  const dateParts1 = dateParts[0].split('-')
  //  console.log(date, dateStr);
  const newDateStr = dateParts1[2] + '/' + dateParts1[1] + '/' + dateParts1[0] + ' ' + dateParts[1];

  return newDateStr;
}


function dateFormJoin(date) {
  const dateStr = date;
  const date1 = dateStr.split(' ');
  const dateParts = date1[0].split('/');
  const newDateStr = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0] + ' ' + date1[1];
  return newDateStr;
}

export default {
  emits: ['search-submit', 'venueId'],
  name: 'BookingCalendar',
  props: {
    events: {
      type: Array,
      default() {
        return [];
      },
    },
    maxCapacity: {
      type: Number,
      default() {
        return null
      }
    },
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      numberOfDays: null,
      afterhour: false,
      eventPax: null,
      valueData: [],
    }
  },
  methods: {
    $_initDataProcessor: function () {
      if (!scheduler.$_dataProcessorInitialized) {
        scheduler.createDataProcessor((action, data, id) => {
          var date = id;
          this.endDate = date.end_date
          this.startDate = date.start_date
          this.eventPax = date.people
          this.submitSearch()
        });
        scheduler.$_dataProcessorInitialized = true;
      }
    },

    getNumberOfDays(startDate, endDate) {

      let start = startDate.split(' ');
      let end = endDate.split(' ');
      start = Date.parse(start[0]);
      end = Date.parse(end[0]);

      let numberOfDays = (end - start) / 1000 / 3600 / 24;

      // special case, is afterhour. when over 8 hour and ending 5:30 or after

      return numberOfDays;
      //  console.log('number of days', this.numberOfDays);
    },

    generateBookingDateObject(startDate, numberOfDays) {
      // this.getNumberOfDays(this.startDate, this.endDate);
      let dates = [];

      let factor = 1000 * 3600 * 24;
      let _startDT = new Date(Date.parse(startDate));
      // let endDT = new Date();
      for (let i = 1; i <= this.numberOfDays; i++) {
        let _endDT = new Date(Date.parse(_startDT) + factor);
        let dateStr =
          _startDT.getDate() +
          '/' +
          (_startDT.getMonth() + 1) +
          '/' +
          _startDT.getFullYear();

        if (numberOfDays > 1) {
          this.startTime = '08:00';
          this.endTime = '19:00';
        }

        let dateObject = {
          StartDate: dateStr,
          EndDate: dateStr,
        };
        dates.push(dateObject);
        _startDT = _endDT;
      }

      return dates;
    },

    submitSearch() {
      let maxUnits = this.fieldCloseHour * 2;
      let minimalOrder = maxUnits - this.units;
      if (minimalOrder < 2) {
        //   console.log(' minimal order is 60 minutes', maxUnits, this.units);
        this.$emit('search-submit', null);
        return;
      }

      if (this.bookingType === 'causal') { // KI 14Jul2022. Added one = to make ===
        this.endDate = this.startDate;
        this.numberOfDays = 1;
      } else {
        this.numberOfDays =
          this.getNumberOfDays(this.startDate, this.endDate) + 1;
      }
      // console.log(this.numberOfDays);

      var _startDate = dateFormJoiner(this.startDate); //this.startDate.replaceAll('-', '/');
      var _endDate = dateFormJoiner(this.endDate); //this.startDate.replaceAll('-', '/');
      var DashDate = dateFormJoiner(this.endDate).split(' ');
      _endDate = new Date( new Date(dateFormJoin(_endDate)) - 1000 * 60 ).toLocaleTimeString('en-US', {
            // en-US can be set to 'default' to use user's browser settings
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
      })
      const slotObject = {
        StartDate: _startDate,
        EndDate: DashDate[0] + ' ' + _endDate,
        VenuePax: this.eventPax, // 0 or 1000 makes not different therefore use 0
        VenueEndTime: dateFormJoiner(this.endDate),
        VenueBookingType: DefaultBookingType,
        VenueBookingStatus: DefaultBookingStatus,

        NumberOfDays: this.numberOfDays,
        AfterHour: this.afterhour,
        Dates: this.generateBookingDateObject(
          this.startDate,
          this.numberOfDays
        ),
      };

      // console.log(      
      //   slotObject,
      //   this.startDate,
      //   this.endDate,
      //   this.numberOfDays
      // );

      this.$emit('search-submit', slotObject);
      this.$eventBus.emit('search-submit', []);
    },

    dataDynamic() {
      for(var i = 0; i < this.maxCapacity; i++) {
         var e = { key: i+1, label: i+1 }
         this.valueData.push(e)
      }
    },

    myDate() {
      var a = new Date();
      var days = new Array(7);
      days[0] = "Sunday";
      days[1] = "Monday";
      days[2] = "Tuesday";
      days[3] = "Wednesday";
      days[4] = "Thursday";
      days[5] = "Friday";
      days[6] = "Saturday";
      var r = days[a.getDay()];
      return r;
    }
  },
  mounted: function () {
    this.dataDynamic()
    scheduler.skin = "material";
    scheduler.config.header = [
      "day",
      "week",
      "month",
      "date",
      "prev",
      "today",
      "next",
    ];
    
    this.$_initDataProcessor();
    // scheduler.config.multi_day = false;
    scheduler.config.first_hour = 8; //MA 7-12-22 Changed time to start at 8am and finish at 7pm
    scheduler.config.last_hour = 19;
    scheduler.config.limit_time_select = true;
    scheduler.config.details_on_create = true;
    scheduler.config.details_on_dblclick = true;
    // scheduler.config.icons_select = ["icon_details","icon_delete"]
    scheduler.xy.min_event_height = 21; // 30 minutes is the shortest duration to be displayed as is
    scheduler.config.drag_resize = false;
    scheduler.config.drag_move = false;
    scheduler.config.drag_create = false;
    scheduler.config.resize_month_events = true;
    scheduler.config.resize_month_timed = true;
    scheduler.config.event_duration = 60;
    scheduler.config.auto_end_date = true;
    scheduler.config.buttons_right = ["dhx_save_btn", "dhx_cancel_btn"];
    scheduler.config.buttons_left = [];
    scheduler.config.time_step = 30;
    scheduler.config.day_date = "%D %M %j";
    scheduler.config.default_date = "%D %j %M %Y";
    scheduler.templates.day_date = function (date) {
      var formatFunc = scheduler.date.date_to_str(scheduler.config.default_date);
      return formatFunc(date);
    };
    scheduler.init(
      this.$refs.SchedulerComponent,
      new Date(new Date().getFullYear(), new Date().getMonth(), 7),
      "month"
    );

    scheduler.plugins({
      limit: true,
      // timeline: true,
      tooltip: true
    });
    scheduler.locale.labels.section_time = 'Start / End Date Time';
    scheduler.config.lightbox.sections = [
      // {name:"description", height:72, map_to:"text", type:"textarea" , focus:true},
      // {
      //   name: "Hours", height: 72, type: "select", map_to: "hours", options: [
      //     { key: "1", label: "1" },
      //     { key: "1.5", label: "1.5" },
      //     { key: "2", label: "2" },
      //     { key: "2.5", label: "2.5" },
      //     { key: "3", label: "3" },
      //     { key: "3.5", label: "3.5" },
      //     { key: "4", label: "4" },
      //   ]
      // },
      {
        name: "People", height: 72, type: "select", map_to: "people", options:scheduler.serverList("type")
      },
      { name: "time", height: 72, type: "time", map_to: "auto", year_range: [new Date().getFullYear(), new Date().getFullYear() + 10] }
    ];
    scheduler.updateCollection("type", this.valueData);
    scheduler.clearAll();
    scheduler.parse(this.$props.events);
  },
};
</script>

<style scoped>
@import "~dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css";
</style>